import React, {useState} from "react";
import {NavLink as RouterNavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import logo from "../assets/logo.png";

import {
    Collapse,
    Container,
    Navbar,
    Nav,
    NavItem,
    NavLink,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";

import {useAuth0} from "@auth0/auth0-react";
import {Avatar, BottomNavigation, BottomNavigationAction, Fab} from "@mui/material";

const NavBar = () => {
    const [mobileNavValue, setMobileNavValue] = useState(false);
    const {
        user,
        isAuthenticated,
        loginWithRedirect,
        logout
    } = useAuth0();

    const logoutWithRedirect = () =>
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            }
        });

    const goHome = () => {
        window.location.href = "/";
    }

    const goToSettings = () => {
        window.location.href = "/profile#settings";
    }

    const goToFollowing = () => {
        window.location.href = "/profile#following";
    }

    return (
        <div className="nav-container">
            <Navbar color="light" light expand="md" container={false}>
                <Container>

                    <div className={"navbar-brand"} onClick={() => goHome()}>
                        <img src={logo} alt="logo" width="73" height="34"/>
                    </div>

                    {isAuthenticated && (
                        <UncontrolledDropdown className="mobile-profile-dropdown">
                            <DropdownToggle nav caret id="profileDropDown">
                                <Avatar src={user.picture} alt={user.name} className="nav-avatar"/>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem header>
                                    <div className="left-side">
                                        <Avatar src={user.picture} alt={user.name} className="nav-avatar"/>
                                    </div>
                                    <div className="right-side">
                                        <span className="name">{user.name}</span>
                                        <span className="email">{user.email}</span>
                                    </div>
                                </DropdownItem>
                                <DropdownItem text>
                                    <div className="menu-options">
                                        <div className="option" onClick={() => goToFollowing()}>
                                            <FontAwesomeIcon icon="users" className="following"/>
                                            <span className="option-text">Following</span>
                                        </div>
                                        <div className="option" onClick={() => goToSettings()}>
                                            <FontAwesomeIcon icon="cogs" className="settings"/>
                                            <span className="option-text">Settings</span>
                                        </div>
                                        <div className="option logout" onClick={() => logoutWithRedirect()}>
                                            <FontAwesomeIcon icon="power-off" className="logout"/>
                                            <span className="option-text">Logout</span>
                                        </div>
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    {!isAuthenticated && (
                        <Fab className="mobile-login-button" onClick={() => loginWithRedirect()}>
                            <FontAwesomeIcon icon="sign-in-alt"/> Sign in
                        </Fab>
                    )}

                    <Collapse isOpen={false} navbar>
                        <Nav className="mr-auto" navbar>
                            <NavItem>
                                <NavLink
                                    tag={RouterNavLink}
                                    to="/"
                                    exact
                                    activeClassName="router-link-exact-active"
                                >
                                    Home
                                </NavLink>
                            </NavItem>
                            {isAuthenticated && (
                                <>
                                    <NavItem>
                                        <NavLink
                                            tag={RouterNavLink}
                                            to="/search"
                                            exact
                                            activeClassName="router-link-exact-active"
                                        >
                                            Search
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            tag={RouterNavLink}
                                            to="/profile"
                                            exact
                                            activeClassName="router-link-exact-active"
                                        >
                                            My Library
                                        </NavLink>
                                    </NavItem>
                                </>
                            )}
                        </Nav>

                        <Nav className="d-none d-md-block" navbar>
                            {!isAuthenticated && (
                                <NavItem>
                                    <Button
                                        id="qsLoginBtn"
                                        color="primary"
                                        className="btn-margin"
                                        style={{borderRadius: "10px", background: "#2553c5"}}
                                        onClick={() => loginWithRedirect()}
                                    >
                                        <FontAwesomeIcon icon="sign-in-alt"/> Sign in
                                    </Button>
                                </NavItem>
                            )}
                            {isAuthenticated && (
                                <UncontrolledDropdown className="desktop-profile-dropdown">
                                    <DropdownToggle nav caret id="profileDropDown">
                                        <Avatar src={user.picture} alt={user.name} className="nav-avatar"/>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem header>
                                            <div className="left-side">
                                                <Avatar src={user.picture} alt={user.name} className="nav-avatar"/>
                                            </div>
                                            <div className="right-side">
                                                <span className="name">{user.name}</span>
                                                <span className="email">{user.email}</span>
                                            </div>
                                        </DropdownItem>
                                        <DropdownItem text>
                                            <div className="menu-options">
                                                <div className="option" onClick={() => goToFollowing()}>
                                                    <FontAwesomeIcon icon="users" className="following"/>
                                                    <span className="option-text">Following</span>
                                                </div>
                                                <div className="option" onClick={() => goToSettings()}>
                                                    <FontAwesomeIcon icon="cogs" className="settings"/>
                                                    <span className="option-text">Settings</span>
                                                </div>
                                                <div className="option logout" onClick={() => logoutWithRedirect()}>
                                                    <FontAwesomeIcon icon="power-off" className="logout"/>
                                                    <span className="option-text">Logout</span>
                                                </div>
                                            </div>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            )}
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>

            {isAuthenticated && (
                <div className="mobile-nav-bar">
                    <BottomNavigation value={mobileNavValue} onChange={(event, newValue) => {
                        setMobileNavValue(newValue);
                    }}>
                        <BottomNavigationAction
                            label="Home"
                            value="home"
                            href={"/"}
                            icon={<FontAwesomeIcon icon="home"/>}
                        />
                        <BottomNavigationAction
                            label="Search"
                            value="search"
                            href={"/search"}
                            icon={<FontAwesomeIcon icon="search"/>}
                        />
                        <BottomNavigationAction
                            className="delete-book-button"
                            label="Profile"
                            value="profile"
                            href={"/profile"}
                            icon={<FontAwesomeIcon icon="user"/>}
                        />
                    </BottomNavigation>
                </div>
            )}

        </div>
    );
};

export default NavBar;
